import { render, staticRenderFns } from "./scroll-top.vue?vue&type=template&id=0e6adb01&"
import script from "./scroll-top.vue?vue&type=script&lang=js&"
export * from "./scroll-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports